import initSelect2 from './vendors/select2'
import initSwiper from './vendors/swiper'
// import initSwipenav from './vendors/swipenav'

function initVendors() {
    initSelect2();
    initSwiper();

    // initSwipenav();
}


export default initVendors;


